import angular from 'angular';
import ESignUploadSignatureModal from './eSignUploadSignatureModal';

export default angular
  .module('components.eSignUploadSignatureModal', [])
  .component('eSignUploadSignatureModal', ESignUploadSignatureModal).name;
